export interface ArtikelEinheit {
  id: number;
  name: string;
  title: string
}
